(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-arrae-home"] && !Shopify.designMode) return;
  try {
    
function initAe(root){root.querySelectorAll('.ae').forEach(section=>{if(section.dataset.aeReady)return;section.dataset.aeReady='true';const track=section.querySelector('.ae-grid'),prev=section.querySelector('[data-ae-prev]'),next=section.querySelector('[data-ae-next]');if(!track||!next)return;const update=()=>{prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};const move=d=>track.scrollBy({left:d*((track.firstElementChild?.getBoundingClientRect().width||300)+14),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();});}initAe(document);document.addEventListener('shopify:section:load',()=>initAe(document));

function initAeConcerns(root){
 root.querySelectorAll('.ae--products').forEach(section=>{
  if(section.dataset.concernsReady)return;
  const nav=section.querySelector('.ae-tabs'),track=section.querySelector('.ae-grid');
  if(!nav||!track)return;
  section.dataset.concernsReady='true';
  const buttons=[...nav.querySelectorAll('[data-ae-concern]')],cards=[...track.querySelectorAll('.ae-card')];
  const mobile=matchMedia('(max-width:749px)'),reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let active='all',scrollTimer;
  function select(key){
   active=key;
   buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.aeConcern===key)));
   const selected=buttons.find(button=>button.dataset.aeConcern===key);
   if(selected&&mobile.matches){
    const left=selected.offsetLeft-nav.offsetLeft;
    nav.scrollTo({left:Math.max(0,left-(nav.clientWidth-selected.offsetWidth)/2),behavior:reduced.matches?'auto':'smooth'});
   }
  }
  function syncSwipe(){
   if(!mobile.matches)return;
   const edge=track.getBoundingClientRect().left;
   const card=cards.reduce((best,item)=>Math.abs(item.getBoundingClientRect().left-edge)<Math.abs(best.getBoundingClientRect().left-edge)?item:best,cards[0]);
   if(card)select(card.dataset.aeProduct);
  }
  buttons.forEach(button=>button.addEventListener('click',()=>{
   const key=button.dataset.aeConcern;
   select(key);
   if(mobile.matches){
    cards.forEach(card=>card.hidden=false);
    const target=key==='all'?cards[0]:cards.find(card=>card.dataset.aeProduct===key);
    if(target)track.scrollTo({left:track.scrollLeft+target.getBoundingClientRect().left-track.getBoundingClientRect().left,behavior:reduced.matches?'auto':'smooth'});
   }else{
    cards.forEach(card=>card.hidden=key!=='all'&&card.dataset.aeProduct!==key);
   }
  }));
  track.addEventListener('scroll',()=>{clearTimeout(scrollTimer);scrollTimer=setTimeout(syncSwipe,90)},{passive:true});
  mobile.addEventListener('change',()=>{cards.forEach(card=>card.hidden=false);select('all');if(mobile.matches)syncSwipe();});
 });
}
initAeConcerns(document);
document.addEventListener('shopify:section:load',()=>initAeConcerns(document));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-formula-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ss-formula')){
customElements.define('ss-formula',class extends HTMLElement{
connectedCallback(){
if(this._abort)return;this._abort=new AbortController();const signal=this._abort.signal;
this.track=this.querySelector('.sf-track');this.cards=[...this.querySelectorAll('.sf-card')];this.index=0;
if(!this.cards.length)return;
this.desktop=matchMedia('(min-width:750px)');
const update=()=>{
if(this.desktop.matches){
this.track.scrollLeft=0;
this.cards.forEach((card,i)=>{let offset=(i-this.index+this.cards.length)%this.cards.length;if(offset>Math.floor(this.cards.length/2))offset-=this.cards.length;card.style.setProperty('--sf-position',offset);card.dataset.sfDistance=String(Math.abs(offset));card.dataset.sfHidden=String(Math.abs(offset)>2);card.classList.toggle('is-active',offset===0);});
this.querySelector('.sf-desktop-copy')?.remove();
if(this.cards.length===4){const copy=this.cards[(this.index+2)%4].cloneNode(true);copy.classList.add('sf-desktop-copy');copy.classList.remove('is-active');copy.style.setProperty('--sf-position',-2);copy.dataset.sfDistance='2';copy.setAttribute('aria-hidden','true');copy.setAttribute('inert','');copy.removeAttribute('id');copy.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));copy.querySelectorAll('[data-shopify-editor-block]').forEach(el=>el.removeAttribute('data-shopify-editor-block'));copy.removeAttribute('data-shopify-editor-block');this.track.append(copy);}
}else{
this.querySelector('.sf-desktop-copy')?.remove();const center=this.track.getBoundingClientRect().left+this.track.clientWidth/2;let best=0,distance=Infinity;this.cards.forEach((card,i)=>{card.removeAttribute('data-sf-hidden');const r=card.getBoundingClientRect();const d=Math.abs(r.left+r.width/2-center);if(d<distance){distance=d;best=i}});this.index=best;this.cards.forEach((card,i)=>card.classList.toggle('is-active',i===best));
}
this.querySelector('.sf-status').textContent='Ingredient '+(this.index+1)+' of '+this.cards.length;
};
this.go=i=>{i=(i+this.cards.length)%this.cards.length;if(this.desktop.matches){this.index=i;update();return;}const card=this.cards[i];this.track.scrollTo({left:this.track.scrollLeft+card.getBoundingClientRect().left+card.getBoundingClientRect().width/2-(this.track.getBoundingClientRect().left+this.track.clientWidth/2),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
this.querySelector('.sf-prev').addEventListener('click',()=>this.go(this.index-1),{signal});
this.querySelector('.sf-next').addEventListener('click',()=>this.go(this.index+1),{signal});
this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this._frame);this._frame=requestAnimationFrame(update)},{passive:true,signal});
this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1))}},{signal});
this.querySelectorAll('.sf-details-toggle').forEach(button=>button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!open));this.querySelector('#'+CSS.escape(button.getAttribute('aria-controls'))).hidden=open;},{signal}));
this.addEventListener('keydown',e=>{if(e.key==='Escape')this.querySelectorAll('.sf-details-toggle[aria-expanded=true]').forEach(b=>{b.click();b.focus()})},{signal});
document.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.sf-card');if(card&&this.contains(card))this.go(this.cards.indexOf(card))},{signal});
this._resize=new ResizeObserver(update);this._resize.observe(this.track);requestAnimationFrame(update);
}
disconnectedCallback(){this._abort?.abort();this._abort=null;this._resize?.disconnect();cancelAnimationFrame(this._frame)}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-home-editorial"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ss-home-section'))customElements.define('ss-home-section',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;const tabs=[...this.querySelectorAll('[role="tab"]')];const activate=tab=>{tabs.forEach(t=>{const selected=t===tab;t.setAttribute('aria-selected',String(selected));t.tabIndex=selected?0:-1;const p=this.querySelector('#'+t.getAttribute('aria-controls'));if(p)p.hidden=!selected;});};tabs.forEach((t,i)=>{t.addEventListener('click',()=>activate(t));t.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=(i+1)%tabs.length;if(e.key==='ArrowLeft')next=(i-1+tabs.length)%tabs.length;if(e.key==='Home')next=0;if(e.key==='End')next=tabs.length-1;if(next!==undefined){e.preventDefault();activate(tabs[next]);tabs[next].focus();}});});this.querySelectorAll('[data-scroll]').forEach(b=>b.addEventListener('click',()=>{const track=this.querySelector('.sh-ingredients');if(track)track.scrollBy({left:Number(b.dataset.scroll)*(track.firstElementChild.getBoundingClientRect().width+14),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}));this.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('[role="tabpanel"]');if(panel){const t=this.querySelector('[aria-controls="'+panel.id+'"]');if(t)activate(t);}});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-photo-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ss-photo-reviews'))customElements.define('ss-photo-reviews',class extends HTMLElement{
connectedCallback(){
if(this._abort)return;
this._abort=new AbortController();
const signal=this._abort.signal,track=this.querySelector('.sr-track');
if(!track)return;
const cards=[...track.querySelectorAll('.sr-card')];
const size=()=>{
const bounds=track.getBoundingClientRect();
if(!bounds.width||!cards.length)return;
const positions=cards.map(card=>({card,rect:card.getBoundingClientRect()}));
let visible=positions.filter(({rect})=>Math.max(0,Math.min(rect.right,bounds.right)-Math.max(rect.left,bounds.left))/rect.width>.55);
if(!visible.length)visible=[positions.reduce((a,b)=>Math.abs((a.rect.left+a.rect.right-bounds.left-bounds.right)/2)<Math.abs((b.rect.left+b.rect.right-bounds.left-bounds.right)/2)?a:b)];
const style=getComputedStyle(track);
const height=Math.ceil(Math.max(...visible.map(({rect})=>rect.height))+(parseFloat(style.paddingTop)||0)+(parseFloat(style.paddingBottom)||0));
if(Math.abs(parseFloat(track.style.height||'0')-height)>1)track.style.height=height+'px';
};
const schedule=()=>{cancelAnimationFrame(this._frame);this._frame=requestAnimationFrame(size)};
const move=direction=>{const card=cards[0];if(!card)return;const gap=parseFloat(getComputedStyle(track).gap)||0;track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
this.querySelectorAll('[data-direction]').forEach(b=>b.addEventListener('click',()=>move(Number(b.dataset.direction)),{signal}));
track.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}},{signal});
track.addEventListener('scroll',schedule,{passive:true,signal});
track.addEventListener('scrollend',schedule,{signal});
track.addEventListener('load',schedule,{capture:true,signal});
window.addEventListener('resize',schedule,{passive:true,signal});
this._resize=new ResizeObserver(schedule);cards.forEach(card=>this._resize.observe(card));
document.fonts?.ready.then(()=>{if(!signal.aborted)schedule()});
schedule();
}
disconnectedCallback(){this._abort?.abort();this._abort=null;this._resize?.disconnect();cancelAnimationFrame(this._frame)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-sale-announcement"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ss-sale-bar'))customElements.define('ss-sale-bar',class extends HTMLElement{
connectedCallback(){clearInterval(this.timer);this.update();this.timer=setInterval(()=>this.update(),1000)}
disconnectedCallback(){clearInterval(this.timer)}
update(){const now=Date.now();let remaining=0;if(this.dataset.mode==='daily'){const sast=new Date(now+7200000);remaining=86400-(sast.getUTCHours()*3600+sast.getUTCMinutes()*60+sast.getUTCSeconds());}else{let end=(this.dataset.end||'').trim().replace(' ','T');if(end&&!/(Z|[+-]\d{2}:?\d{2})$/i.test(end))end+='+02:00';remaining=Math.max(0,Math.floor((Date.parse(end)-now)/1000))||0;}const values={hours:Math.floor(remaining/3600),minutes:Math.floor(remaining/60)%60,seconds:remaining%60};Object.entries(values).forEach(([unit,n])=>{const target=this.querySelector('[data-unit="'+unit+'"]');if(target)target.textContent=String(n).padStart(2,'0')});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-turmeric-interactive"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ss-tap-listicle'))customElements.define('ss-tap-listicle',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.steps=Array.from(this.querySelectorAll('[data-step]'));this.index=0;this.dialog=this.querySelector('dialog');this.back=this.querySelector('[data-back]');this.next=this.querySelector('[data-next]');this.progress=this.querySelector('[role="progressbar"]');this.setAttribute('data-enhanced','');this.onClick=e=>{if(e.target.closest('[data-back]'))this.show(this.index-1);if(e.target.closest('[data-next]')){if(this.index===this.steps.length-1)this.openOffer();else this.show(this.index+1)}if(e.target.closest('[data-close]'))this.dialog.close();const trigger=e.target.closest('[data-offer-open],.sst-final .ss-bf-button');if(trigger){e.preventDefault();this.openOffer()}};this.addEventListener('click',this.onClick);this.onSelect=e=>{const blockId=e.detail?.blockId;const i=this.steps.findIndex(s=>s.dataset.blockId===blockId);if(i>=0)this.show(i)};document.addEventListener('shopify:block:select',this.onSelect);this.onDialogClick=e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close()}};this.dialog.addEventListener('click',this.onDialogClick);this.onClose=()=>{document.documentElement.style.overflow=this.previousOverflow||'';if(this.offerOpener?.isConnected)this.offerOpener.focus({preventScroll:true})};this.dialog.addEventListener('close',this.onClose);this.show(0,false)}
disconnectedCallback(){document.removeEventListener('shopify:block:select',this.onSelect);this.removeEventListener('click',this.onClick);this.dialog?.removeEventListener('click',this.onDialogClick);this.dialog?.removeEventListener('close',this.onClose);if(this.dialog?.open){this.dialog.close();document.documentElement.style.overflow=this.previousOverflow||''}this.ready=false}
show(index,focus=true){this.index=Math.max(0,Math.min(index,this.steps.length-1));this.steps.forEach((s,i)=>{s.hidden=i!==this.index});this.back.hidden=this.index===0;this.next.textContent=this.index===0?this.dataset.startLabel:this.index===this.steps.length-1?this.dataset.offerLabel:this.dataset.nextLabel;this.querySelector('[data-current]').textContent=String(this.index+1).padStart(2,'0');this.progress.setAttribute('aria-valuenow',String(this.index+1));this.progress.setAttribute('aria-valuetext','Step '+(this.index+1)+' of '+this.steps.length);const segments=Array.from(this.querySelectorAll('.sst-segments i'));const filled=Math.ceil((this.index+1)/this.steps.length*segments.length);segments.forEach((s,i)=>s.classList.toggle('is-complete',i<filled));if(focus){this.steps[this.index].querySelector('h1,h2')?.focus({preventScroll:true});this.scrollIntoView({behavior:'instant',block:'start'})}this.dispatchEvent(new CustomEvent('ss:listicle_step',{bubbles:true,detail:{step:this.index+1,total:this.steps.length}}))}
openOffer(){if(this.dialog.open)return;this.offerOpener=document.activeElement;this.previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';this.dialog.showModal();this.dispatchEvent(new CustomEvent('ss:listicle_offer_open',{bubbles:true,detail:{step:this.index+1}}))}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-turmeric-listicle"] && !Shopify.designMode) return;
  try {
    
function updateTurmericTimers(){document.querySelectorAll('[data-ss-countdown]').forEach(el=>{const end=Date.parse(el.dataset.ssCountdown);const left=Math.floor((end-Date.now())/1000);el.hidden=!Number.isFinite(end)||left<=0;if(el.hidden)return;el.querySelector('[data-hours]').textContent=String(Math.floor(left/3600)).padStart(2,'0');el.querySelector('[data-minutes]').textContent=String(Math.floor(left/60)%60).padStart(2,'0');el.querySelector('[data-seconds]').textContent=String(left%60).padStart(2,'0');});}
updateTurmericTimers();setInterval(updateTurmericTimers,1000);

  } catch(e) { console.error(e); }
})();
})();
